import React, { Component } from 'react';
import moment from 'moment-jalaali';

export default class ContractPrint extends Component {
    state = { contract: null, loading: true };

    componentDidMount() {
        const id = window.location.pathname.split('/').pop();
        this.fetchContract(id);
    }

    async fetchContract(id) {
        try {
            const res = await fetch(`/api/v1/contract/get`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: parseInt(id) }),
            });
            const data = await res.json();
            if (data.status === 1) {
                this.setState({ contract: data.record, loading: false }, () => {
                    setTimeout(() => window.print(), 500);
                });
            }
        } catch (err) {
            console.error(err);
        }
    }

    numberWithCommas(x) {
        return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '0';
    }

    render() {
        const { contract, loading } = this.state;
        if (loading || !contract) return <div style={{ padding: 50, fontFamily: 'Tahoma' }}>در حال بارگذاری...</div>;

        return (
            <div style={{
                fontFamily: 'Tahoma, sans-serif',
                direction: 'rtl',
                width: '210mm',
                maxWidth: '100%',
                margin: 'auto',
                padding: '12mm',
                color: '#000',
                boxSizing: 'border-box',
                fontSize: '9pt',
                lineHeight: '1.6',
            }}>
                {/* استایل‌های چاپ */}
                <style>{`
                    @page {
                        size: A4 portrait;
                        margin: 10mm;
                    }
                    @media print {
                        body { background: white; }
                        .no-print { display: none !important; }
                    }
                `}</style>

                {/* سربرگ */}
                <div style={{ textAlign: 'center', borderBottom: '2px solid #000', paddingBottom: 6, marginBottom: 16 }}>
                    <h3 style={{ margin: 0, fontSize: '13pt' }}>شرکت خدمات مالی و مالیاتی</h3>
                    <p style={{ margin: 2, fontSize: '8pt' }}>تهران، خیابان ولیعصر – تلفن: ۰۲۱-۱۲۳۴۵۶۷۸</p>
                    <p style={{ margin: 0, fontSize: '8pt' }}>شماره ثبت: ۱۲۳۴۵ – کد اقتصادی: ۴۱۱۱۱۱۱۱۱</p>
                </div>

                <h2 style={{ textAlign: 'center', margin: '14px 0', fontSize: '12pt' }}>قرارداد ارائه خدمات</h2>

                {/* اطلاعات اصلی */}
                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 16 }}>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #000', padding: '5px 8px', fontWeight: 'bold', width: '25%' }}>مشتری</td>
                            <td style={{ border: '1px solid #000', padding: '5px 8px' }}>{contract.customerName}</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #000', padding: '5px 8px', fontWeight: 'bold' }}>شماره قرارداد</td>
                            <td style={{ border: '1px solid #000', padding: '5px 8px' }}>{contract.contractNumber}</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #000', padding: '5px 8px', fontWeight: 'bold' }}>تاریخ شروع</td>
                            <td style={{ border: '1px solid #000', padding: '5px 8px' }}>{contract.startDate}</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #000', padding: '5px 8px', fontWeight: 'bold' }}>تاریخ پایان</td>
                            <td style={{ border: '1px solid #000', padding: '5px 8px' }}>{contract.endDate ? contract.endDate : 'نامحدود'}</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #000', padding: '5px 8px', fontWeight: 'bold' }}>سال مالی</td>
                            <td style={{ border: '1px solid #000', padding: '5px 8px' }}>{contract.fiscalYear}</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #000', padding: '5px 8px', fontWeight: 'bold' }}>مبلغ کل (تومان)</td>
                            <td style={{ border: '1px solid #000', padding: '5px 8px' }}>{this.numberWithCommas(contract.amount)}</td>
                        </tr>
                    </tbody>
                </table>

                {/* خدمات تحت پوشش */}
                <h3 style={{ fontSize: '10pt', marginBottom: 6 }}>خدمات تحت پوشش</h3>
                {contract.services && contract.services.length > 0 ? (
                    <ul style={{ margin: '0 0 14px 0', paddingRight: 18, fontSize: '9pt' }}>
                        {contract.services.map((s, i) => <li key={i}>{s.title}</li>)}
                    </ul>
                ) : <p style={{ fontSize: '9pt', fontStyle: 'italic' }}>هیچ خدمتی انتخاب نشده است.</p>}

                {/* جدول پرداخت‌ها */}
                <h3 style={{ fontSize: '10pt', marginBottom: 6 }}>برنامه پرداخت‌ها</h3>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 20, fontSize: '8.5pt' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#eee' }}>
                            <th style={{ border: '1px solid #000', padding: '4px 6px' }}>ردیف</th>
                            <th style={{ border: '1px solid #000', padding: '4px 6px' }}>تاریخ</th>
                            <th style={{ border: '1px solid #000', padding: '4px 6px' }}>مبلغ (تومان)</th>
                            <th style={{ border: '1px solid #000', padding: '4px 6px' }}>توضیح</th>
                            <th style={{ border: '1px solid #000', padding: '4px 6px' }}>دریافت شده</th>
                        </tr>
                    </thead>
                    <tbody>
                        {contract.payments && contract.payments.length > 0 ? (
                            contract.payments.map((p, idx) => (
                                <tr key={idx}>
                                    <td style={{ border: '1px solid #000', padding: '4px 6px', textAlign: 'center' }}>{idx + 1}</td>
                                    <td style={{ border: '1px solid #000', padding: '4px 6px' }}>{moment(p.paymentDate).format('jYYYY/jMM/jDD')}</td>
                                    <td style={{ border: '1px solid #000', padding: '4px 6px', textAlign: 'right' }}>{this.numberWithCommas(p.amount)}</td>
                                    <td style={{ border: '1px solid #000', padding: '4px 6px' }}>{p.description || '-'}</td>
                                    <td style={{ border: '1px solid #000', padding: '4px 6px', textAlign: 'center' }}>{p.isReceived ? '✓' : '✗'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="5" style={{ border: '1px solid #000', padding: 8, textAlign: 'center' }}>پرداختی تعریف نشده</td></tr>
                        )}
                    </tbody>
                </table>

                {/* شرایط و امضاها */}
                <div style={{ fontSize: '8pt', marginBottom: 16 }}>
                    <strong>شرایط:</strong> این قرارداد بر اساس قوانین جاری کشور و با رعایت مفاد مندرج در پشت برگه منعقد می‌گردد.
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 40 }}>
                    <div style={{ width: '40%', borderTop: '1px solid #000', textAlign: 'center', paddingTop: 6, fontSize: '8pt' }}>
                        مهر و امضای شرکت
                    </div>
                    <div style={{ width: '40%', borderTop: '1px solid #000', textAlign: 'center', paddingTop: 6, fontSize: '8pt' }}>
                        امضای مشتری
                    </div>
                </div>
            </div>
        );
    }
}